import { BaseConfig } from "../config.interface";
import { Size } from "../util";

interface IMultiSelectConfig<T> {
    label?: string;
    optionLabel?: keyof T & string;
    optionValue?: keyof T & string;
    autocomplete?: string;
    clear?: boolean;
    placeholder?: string;
    showToggleAll?: boolean;
    selectionLimit: number;
    selectedItemsLabel?: string;
    size: Size;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class MultiSelectConfig<T = any> extends BaseConfig<IMultiSelectConfig<T>> implements IMultiSelectConfig<T> {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Property key of the option's label. 
     * - On primitive values defaults to `label`.
     * - On objects values this value assumes its a key of the value (`value.LABEL`) or fallbacks to `label`.
     */
    optionLabel?: keyof T & string;
    /**
     * Property key of the option's value. 
     * - On primitive values or emptydefaults to `value`.
     * - On objects values this value assumes its a key of the value (`value.KEY`) or  fallbacks to `value`. 
     */
    optionValue?: keyof T & string;
    /**
     * Property key of the option's group. 
     */
    optionGroup?: keyof T & string;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Show clear button.
     */

    clear?: boolean;
    /**
     * Placeholder on empty value.
     */
    placeholder?: string;
    /**
     * Show toggle all button.
     */
    showToggleAll?: boolean;
    /**
     * Set a maximum selection limit.
     */
    selectionLimit: number;
    /**
     * Define a label for selected label. Use `{0}` to insert the number in the label.
     * @example "{0} selected"
     */
    selectedItemsLabel?: string;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size;

    withValue<TObj>(value?: (keyof TObj) & string, label?: (keyof TObj) & string): MultiSelectConfig<TObj> {
        return new MultiSelectConfig<TObj>({
            ...this,
            optionValue: value,
            optionLabel: label,
        });
    }

    /**
     * This is the base theme.
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new MultiSelectConfig({
            placeholder:        "COMPONENT.PLEASE_SELECT",
            clear:              true,
            showToggleAll:      true,
            selectionLimit:     3,
            selectedItemsLabel: "COMPONENT.ITEMS_SELECTED",
            size:               "medium"
        }),
        Department: new MultiSelectConfig({
            placeholder:        "COMPONENT.DEPARTMENT_SELECT",
            clear:              true,
            showToggleAll:      true,
            selectionLimit:     3,
            selectedItemsLabel: "COMPONENT.DEPARTMENTS_SELECTED",
            size:               "medium"
        }),
        ZeroSelectionLimit: new MultiSelectConfig({
            placeholder:        "Bitte auswählen",
            clear:              true,
            showToggleAll:      true,
            selectionLimit:     0,
            selectedItemsLabel: "{0} ausgewählt",
            size:               "medium"
        }),
    };

}
